import echarts from "echarts";

export function formatTime(pattern, date) {
  if (!date) return "";
  return echarts.format.formatTime(pattern, date);
}

/**
 * utc时间(秒数) 转 北京时间毫秒数
 * @param {int} utcTimeNumber
 */
function utcToCst(utcTimeNumber) {
  // 北京时间比UTC时间早8小时
  return (parseInt(utcTimeNumber)) * 1000;
}

/**
 * 本地毫秒数时间戳 new Date().getTime()
 * @param {int} timeStamp
 */
function cstToUtcNumber(timeStamp) {
  return Math.round(Number(timeStamp) / 1000) + 8 * 60 * 60;
}

const date = { formatTime, utcToCst, cstToUtcNumber };

export default date;
